import React, {  useState } from 'react';
import { Paper, List, ListItemButton, ListItemText, Chip, TextField} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';


 export function BranchColumn({   items,   onSelect,   onAddBranch,   onAddDevice,             selected,   allowDevice}) {
   /* branch input */
   const [addingBranch, setAddingBranch] = useState(false);
   const [branchLabel , setBranchLabel ] = useState('');
   /* device input */
   const [addingDevice, setAddingDevice] = useState(false);
   const [deviceLabel , setDeviceLabel ] = useState('');

   return (
     <Paper sx={{ width: 220, overflowY: 'auto', mr: 1 }}>
       <List dense disablePadding>
         {items.map(i => (
           <ListItemButton key={i.key} onClick={() => onSelect(i)} selected={i.label === selected}>
             <ListItemText primary={i.label} sx={{ color: colour(i.status) }} />
             {i.isDevice && <Chip label="device" size="small" sx={{ ml: 1 }} />}
           </ListItemButton>
         ))}

         {/* ───────────────────── add-BRANCH row ─────────────────── */}
         {addingBranch ? (
          <ListItemButton divider disableGutters>
            <TextField
              size="small" autoFocus fullWidth
              value={branchLabel}
              onChange={e => setBranchLabel(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter') commitBranch();
                if (e.key === 'Escape') cancelBranch();
              }}
            />
            <IconButton size="small" onClick={commitBranch}><CheckIcon /></IconButton>
            <IconButton size="small" onClick={cancelBranch}><CloseIcon /></IconButton>
          </ListItemButton>
        ) : (
           <ListItemButton onClick={() => setAddingBranch(true)}>
             <AddIcon fontSize="small" sx={{ mr: 1 }} />
             <ListItemText primary="Branch" />
           </ListItemButton>
        )}

        {/* ───────────────────── add-DEVICE row ─────────────────── */}
        {allowDevice && (addingDevice ? (
          <ListItemButton divider disableGutters>
            <TextField
              size="small" autoFocus fullWidth
              value={deviceLabel}
              onChange={e => setDeviceLabel(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter') commitDevice();
                if (e.key === 'Escape') cancelDevice();
              }}
            />
            <IconButton size="small" onClick={commitDevice}><CheckIcon /></IconButton>
            <IconButton size="small" onClick={cancelDevice}><CloseIcon /></IconButton>
          </ListItemButton>
        ) : (
          <ListItemButton onClick={() => setAddingDevice(true)}>
            <AddIcon fontSize="small" sx={{ mr: 1 }} />
            <ListItemText primary="Device" />
          </ListItemButton>
        ))}

      </List>
    </Paper>
  );
  /* helpers – branch ------------------------------------------------ */
  function commitBranch() {
    if (!branchLabel.trim()) return;
    onAddBranch(branchLabel.trim());
    setBranchLabel('');
    setAddingBranch(false);
  }
  function cancelBranch() {
    setBranchLabel('');
    setAddingBranch(false);
  }

  /* helpers – device ------------------------------------------------ */
  function commitDevice() {
    if (!deviceLabel.trim()) return;
    onAddDevice(deviceLabel.trim());
    setDeviceLabel('');
    setAddingDevice(false);
  }
  function cancelDevice() {
    setDeviceLabel('');
    setAddingDevice(false);
  }

}

function colour(status) {
  return status === 'good'  ? 'inherit'
       : status === 'mixed' ? 'orange'
       : 'red';
}
